<template>
  <div class="container">
    <div class="alert alert-danger" v-if="error" role="alert">
      {{ error }}
    </div>
    <form action="post" @submit.prevent="saveNote()" :class="{ 'was-validated': submitted}">

      <div class="form-group">
        <label for="note">Notering</label>
        <textarea class="form-control" id="note" rows="10" required v-model="note.Notes"></textarea>
      </div>

      <button type="button" class="btn btn-link" @click="$router.go(-1)">Avbryt</button>
      <button type="submit" class="btn btn-primary" @click="submitted = true">Spara</button>
    </form>
  </div>
</template>
<script>
import appService from '../appService'

export default {
  props: ['id'],

  data () {
    return {
      submitted: false,
      note: {},
      error: ''
    }
  },

  created() {
    appService.getNote(this.id)
    .then(note => { this.note = note })
  },

  methods: {
    saveNote () {
      appService.updateNote(this.note)
      .then(() => { this.$router.go(-1) })
      .catch(() => { this.error = 'Det gick inte att spara.' })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/NoteEdit.vue